import { Controller } from "stimulus"
import { hasParentNode, getFirstFocusableChild } from '../support/util';

export default class extends Controller {
    initialize() {
        this.overlayContainer = null;
        this.firstFocusableChild = null;
        this.ignoreFocusChanges = false;
    }

    disconnect() {
        document.removeEventListener('focus', this.onFocusChange, true);
    }

    lockFocusInsideOverlay(overlay) {
        this.overlayContainer = overlay;
        this.firstFocusableChild = getFirstFocusableChild(this.overlayContainer);

        this.focusFirstChild();
        document.addEventListener('focus', this.onFocusChange, true);
    }

    unlockFocusFromOverlay() {
        this.overlayContainer = null;
        document.removeEventListener('focus', this.onFocusChange, true);
    }

    focusFirstChild = () => {
        if (!this.firstFocusableChild) {
            return;
        }

        this.ignoreFocusChanges = true;
        this.firstFocusableChild.focus();
        this.ignoreFocusChanges = false;
    }

    // Once the focus leaves overlay container, return focus back inside
    onFocusChange = () => {
        if (!this.ignoreFocusChanges && !hasParentNode(event.target, this.overlayContainer)) {
            this.focusFirstChild(this.overlayContainer);
        }
    }
}
